<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="legacy-handicap-dialog">
            <q-card-section class="text-h6">{{ ts('legacyHandicapTitle') }}</q-card-section>
            <q-card-section class="q-pt-none">{{ ts('legacyHandicapExplanation') }}</q-card-section>

            <q-card-section class="scroll legacy-handicap-list q-pt-none">
                <div v-for="group in groups" :key="group.id" class="q-mb-lg">
                    <div class="text-subtitle1 text-weight-medium">
                        {{ ts('legacyHandicapUnknownRace', { label: group.label }) }}
                    </div>
                    <div v-for="boatClass in group.classes" :key="boatClass.boatClassId" class="q-ml-md q-mb-sm">
                        <div class="text-weight-medium">{{ boatClass.name }}</div>
                        <div v-for="boat in boatClass.boats" :key="boat.sail" class="row q-col-gutter-sm">
                            <span class="col-5">{{ boat.sail }}</span>
                            <span class="col">{{ ts('legacyHandicapProposed') }}: {{ boat.handicap }}</span>
                        </div>
                    </div>
                    <q-select
                        v-model="selected[group.id]"
                        :options="raceOptions"
                        :label="ts('legacyHandicapChooseRace', { label: group.label })"
                        outlined
                        dense
                        emit-value
                        map-options
                    />
                </div>
                <div v-if="raceOptions.length === 0" class="text-negative">
                    {{ ts('legacyHandicapNoRaces') }}
                </div>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat color="primary" :label="ts('cancel')" @click="onDialogCancel" />
                <q-btn color="primary" :label="ts('importEvent')" :disable="!complete" @click="confirm" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import type { LegacyHandicapAssignments, LegacyHandicapGroup } from '@/network/legacyHandicaps'
import { ts } from '@/plugins/i18nFormat'
import { useDialogPluginComponent } from 'quasar'
import { computed, reactive } from 'vue'

const props = defineProps<{ groups: LegacyHandicapGroup[]; races: number[] }>()
defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const selected = reactive<Record<string, number | null>>({})
const raceOptions = computed(() =>
    [...new Set(props.races)].sort((a, b) => a - b).map(race => ({
        label: ts('raceNum', { num: race }),
        value: race,
    }))
)
const complete = computed(() =>
    props.groups.every(group => raceOptions.value.some(option => option.value === selected[group.id]))
)

function confirm(): void {
    if (!complete.value)
        return

    const assignments: LegacyHandicapAssignments = {}
    props.groups.forEach(group => {
        const race = selected[group.id]
        if (race !== null && race !== undefined)
            assignments[group.id] = race
    })
    onDialogOK(assignments)
}
</script>

<style scoped>
.legacy-handicap-dialog {
    width: min(640px, 95vw);
    max-width: 95vw;
}

.legacy-handicap-list {
    max-height: 60vh;
}
</style>
